import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { useAuth } from './hooks/useAuth';
import LoginPage from './components/LoginPage';
import AppShell from './components/AppShell';
import LoadingScreen from './components/LoadingScreen';
import PersonSchedulePage from './components/schedule/PersonSchedulePage';
import KidsAvailabilityPage from './components/schedule/KidsAvailabilityPage';
import KidsPublicAvailabilityPage from './components/schedule/KidsPublicAvailabilityPage';
import ServingAvailabilityPage from './components/schedule/ServingAvailabilityPage';
import KidsDemo from './components/demo/KidsDemo';
import CheckInPage from './components/checkin/CheckInPage';

function AuthenticatedApp() {
  const { user, loading } = useAuth();
  if (loading) return <LoadingScreen />;
  if (!user) return <LoginPage />;
  return <AppShell />;
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/s/:personId" element={<PersonSchedulePage />} />
        <Route path="/s/:personId/print" element={<PersonSchedulePage />} />
        <Route path="/serve/:personId" element={<ServingAvailabilityPage />} />
        <Route path="/avail/:personId" element={<KidsAvailabilityPage />} />
        <Route path="/kids-availability" element={<KidsPublicAvailabilityPage />} />
        <Route path="/demo" element={<KidsDemo />} />
        <Route path="/checkin/:dateParam" element={<CheckInPage />} />
        <Route path="/checkin" element={<CheckInPage />} />
        {/* Memorable aliases for the people running the check-in table. */}
        <Route path="/check-in/:dateParam" element={<CheckInPage />} />
        <Route path="/check-in" element={<CheckInPage />} />
        <Route path="/sign-in/:dateParam" element={<CheckInPage />} />
        <Route path="/sign-in" element={<CheckInPage />} />
        <Route path="*" element={<AuthenticatedApp />} />
      </Routes>
    </BrowserRouter>
  );
}
